<div class="container">
  <mat-toolbar color="primary" class="main-toolbar">
    <form [formGroup]="form" style="width: 100%;">
      <mat-form-field appearance="fill" style="width: 100%;">
          <input #inp matInput placeholder="song or artist name" class="mt-1 hidden" formControlName="query" (blur)="onDone($event)" (input)="onChanged($event)" (click)="onClick($event)">
          <i class="fa fa-search h4 float-right" (click)="inp.click()"></i>
      </mat-form-field>
    </form>
  </mat-toolbar>

    <div class="content">
        <div class="logo">
          <mat-icon>music_note</mat-icon>
          <div>Audio Player</div>
      </div>

      <mat-list color="primary">
        <h2 mat-subheader (click)="getAllSongs()"><span class="songs h4">Songs</span></h2>
        <hr class="mt-0">
        <mat-list-item *ngFor="let file of files; let i = index" (click)="openFile(file, i)">
          <mat-icon color="primary" mat-list-icon>music_note</mat-icon>
          <h4 mat-line>{{ file.songTitle }}</h4>
          <h5 mat-line>by {{ file.artist }}</h5>
          <mat-icon color="primary" *ngIf="currentFile.index === i && !state?.error">volume_up</mat-icon>
          <h6 *ngIf="currentFile.index === i && state?.error">ERROR</h6>
          <mat-divider></mat-divider>
        </mat-list-item>
      </mat-list>
    </div>

    <div class="media-footer">
      <mat-toolbar color="primary">
        <mat-toolbar-row>
           {{ state?.readableCurrentTime }}
           <mat-slider class="time-slider slidebar" min="0" [max]="state?.duration" step="1" [value]="state?.currentTime" (input)="onSliderChangeEnd($event)" [disabled]="state?.error || currentFile.index === undefined"></mat-slider>
           {{ state?.readableDuration }}
        </mat-toolbar-row>

        <mat-toolbar-row class="media-action-bar ctrls">
          <button mat-button [disabled]="isFirstPlaying()" (click)="previous()">
            <mat-icon mat-list-icon>skip_previous</mat-icon>
          </button>
          <button mat-button (click)="play()" [disabled]="state?.error" *ngIf="!state?.playing">
            <mat-icon mat-list-icon>play_circle_filled</mat-icon>
          </button>
          <button mat-button (click)="pause()" *ngIf="state?.playing">
            <mat-icon mat-list-icon>pause</mat-icon>
          </button>
          <button  mat-button [disabled]="isLastPlaying()" (click)="next()">
            <mat-icon mat-list-icon>skip_next</mat-icon>
          </button>
        </mat-toolbar-row>

      </mat-toolbar>
    </div>
</div>